import { render, staticRenderFns } from "./parser.vue?vue&type=template&id=1ff8fa42&scoped=true"
import script from "./parser.vue?vue&type=script&lang=js"
export * from "./parser.vue?vue&type=script&lang=js"
import style0 from "./parser.vue?vue&type=style&index=0&id=1ff8fa42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8fa42",
  null
  
)

export default component.exports